import Button from '@components/buttons/button.jsx';
import PropTypes from 'prop-types';

TwitchChatbotActive.propTypes = {
  disconnectChatbot: PropTypes.func.isRequired,
  disableConnectionButton: PropTypes.bool.isRequired,
};

export default function TwitchChatbotActive({
  disconnectChatbot,
  disableConnectionButton,
}) {
  return (
    <div className="py-6">
      <article className="prose text-sm">
        You need to <i>disconnect</i> the chatbot before you make any changes
      </article>
      <Button
        onClick={disconnectChatbot}
        mode="button"
        style="primary"
        className="mt-4"
        analyticsTrackingName="disconnect-twitch-chatbot"
        disabled={disableConnectionButton}
      >
        Disconnect Chatbot
      </Button>
    </div>
  );
}
